import React from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Title from 'evcharging/components/Title';
import Baget from 'evcharging/components/Baget';
import Paragraph from 'evcharging/components/Paragraph';
import Responsible from 'evcharging/components/Responsible';
import Box from 'evcharging/components/Box';
import safeAndReliable from 'evcharging/assets/ev-charger/safeAndReliable.png';
import universalCharger from 'evcharging/assets/ev-charger/universalCharger.png';
import support from 'evcharging/assets/ev-charger/suport.png';
import Image from 'next/image';
import Spacer from 'evcharging/components/Spacer';
import useI18n from 'evcharging/hooks/useI18n';
import Desktop from 'evcharging/components/Desktop';
import Mobile from 'evcharging/components/Mobile';

const SafeAndReliable = () => {
  const { t } = useI18n();

  return (
    <Section>
      <Container maxWidth={1070}>
        <Spacer value={0} mobile={10} />
        <Responsible fractions={[49, 50]} mobileReverse>
          <Box>
            <Spacer value={48} mobile={24} />
            <Baget>{t('charger.safe.label')}</Baget>
            <Spacer value={16} />
            <Title variant={'h2'}>{t('charger.safe.title')}</Title>
            <Spacer value={16} />
            <Paragraph color={'middle'}>{t('charger.safe.body')}</Paragraph>
          </Box>
          <Desktop>
            <Image src={safeAndReliable} alt={t('charger.safe.alt')} width={522} height={399} />
          </Desktop>
          <Mobile>
            <Image
              src={safeAndReliable}
              alt={t('charger.safe.alt')}
              loading={'lazy'}
              width={522}
              height={399}
            />
          </Mobile>
        </Responsible>
        <Spacer value={90} mobile={32} />

        <Responsible fractions={[48, 50]}>
          <Image
            src={universalCharger}
            alt={t('charger.compatible.alt')}
            width={522}
            height={399}
          />
          <Box paddingLeft={20}>
            <Spacer value={48} mobile={24} />
            <Baget>{t('charger.compatible.label')}</Baget>
            <Spacer value={12} />
            <Title variant={'h2'} fontSize={34}>
              {t('charger.compatible.title')}
            </Title>
            <Spacer value={16} />
            <Paragraph color={'middle'}>{t('charger.compatible.body')}</Paragraph>
          </Box>
        </Responsible>
        <Spacer value={90} mobile={32} />

        <Responsible fractions={[48, 49]} mobileReverse>
          <Box>
            <Spacer value={48} mobile={24} />
            <Baget>{t('charger.support.label')}</Baget>
            <Spacer value={12} />
            <Title fontSize={34} variant={'h2'}>
              {t('charger.support.title')}
            </Title>
            <Spacer value={16} />
            <Paragraph color={'middle'}>{t('charger.support.body')}</Paragraph>
          </Box>
          <Image src={support} alt={t('charger.support.alt')} width={522} height={399} />
        </Responsible>
      </Container>
    </Section>
  );
};

export default SafeAndReliable;
